import { render, staticRenderFns } from "./GeneralPublicInvoiceItem.vue?vue&type=template&id=4cd94562"
import script from "./GeneralPublicInvoiceItem.vue?vue&type=script&lang=js"
export * from "./GeneralPublicInvoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd94562')) {
      api.createRecord('4cd94562', component.options)
    } else {
      api.reload('4cd94562', component.options)
    }
    module.hot.accept("./GeneralPublicInvoiceItem.vue?vue&type=template&id=4cd94562", function () {
      api.rerender('4cd94562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/treasury_accounts/GeneralPublicInvoiceItem.vue"
export default component.exports